import {StepModel} from "./step";
import {ProjectModel} from "./project";

export class ExperienceModel extends ProjectModel{
    private _responsibilities: Array<string> = []
    private _company: string = ''

    get responsibilities(): Array<string> {
        return this._responsibilities;
    }

    set responsibilities(value: Array<string>) {
        this._responsibilities = value;
    }

    get company(): string {
        return this._company;
    }

    set company(value: string) {
        this._company = value;
    }
}